<template>
  <v-dialog v-model="value" @click:outside="close" persistent width="500px">
    <v-card>
      <div class="px-6 py-4 d-flex justify-space-between">
        <h5 class="title">Анализ платежеспособности</h5>
        <v-btn icon @click="close">
          <v-icon small>fas fa-times</v-icon>
        </v-btn>
      </div>
      <v-card-text>
        <h3 class="mb-2 title" style="font-size: initial!important;" v-if="bank">Банк: {{bank}}</h3>
        <h3 v-if="user" class="title" style="font-size: initial!important">ФИО: {{user}}</h3>
        <v-list>
          <v-list-item class="pa-0"
                       :key="item.id"
                       v-for="item in analysis">
            <v-progress-circular
              v-if="loading"
              color="primary"
              size="20"
              width="2"
              indeterminate
            ></v-progress-circular>
            <template v-else>
              <v-icon v-if="item.success" style="width: 25px; height: 25px;" x-small color="#fff"
                      class="success pa-1 circle-radius">fas fa-check
              </v-icon>
              <v-icon v-else style="width: 25px; height: 25px;" x-small color="#fff" class="error pa-1 circle-radius">
                fas fa-times
              </v-icon>
            </template>
            <span class="d-inline-block ml-2">{{item.text}}</span>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>


<script>
  export default {
    name: 'solvency-analysis',
    props: {
      bank: {
        type: String
      },
      user: {
        type: String
      },
      value: {
        type: Boolean
      },
      analysis: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        loading: false,
      }
    },
    methods: {
      close() {
        this.$emit('input', false)
      },
    },
    created() {
    }
  }
</script>
